import React, { useState, useEffect } from 'react';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { API } from '../../../API/API';
import Number from '../../../components/Number/Number';
import GridDefaultShimmer from '../../../components/GridDefaultShimmer/GridDefaultShimmer';
import ColEdit from '../../../components/ColEdit/ColEdit';
import { useParams } from 'react-router-dom';
import BenefitNewBusiness from '../Benefit/BenefitNewBusiness/BenefitNewBusiness';

const EmpExtraBusiness = (props) => {

    const params = useParams();

    const [data, setData] = useState([]);
    const [oData, setOData] = useState([]);

    const [filterValue, setFilterValue] = useState('true');
    const [filterData] = useState([{
        key: 'true',
        text: 'Идэвхтэй'
    }, {
        key: 'false',
        text: 'Идэвхгүй'
    }]);

    const [showAddBenefit, setShowAddBenefit] = useState(false);
    const [dUser, setDUser] = useState({});
    const [loading, setLoading] = useState(false);

    const [columns] = useState([{
        name: 'Нэмэгдэл',
        fieldName: 'extraname',
        minWidth: 350,
        onRender: (item) => {
            return (
                <ColEdit onClick={() => onEditClick(item.entryid)}>
                    {item.extraname}
                </ColEdit>
            );
        }
    }, {
        name: 'Нэмэгдлийн хэмжээ',
        fieldName: 'count',
        onRender: (item) => {
            return (
                <Number value={item.count} csymbol={item.calctype == "AT" ? "₮" : "%"} />
            );
        }
    }, {
        name: 'Олгох давтамж',
        fieldName: 'frequencyname'
    }, {
        name: 'Эхлэх огноо',
        fieldName: 'begindate'
    }, {
        name: 'Дуусах огноо',
        fieldName: 'enddate'
    }]);

    const [entryid, setEntryId] = useState(-1);

    const onEditClick = (p_entryid) => {
        setEntryId(p_entryid);
        setShowAddBenefit(true);
    }

    const getData = async (p_filter) => {
        let tData = [];
        let tDUser = {};
        if (params?.empid > 0) {
            try {
                setLoading(true);
                await API.get('/api/humanresource/employee/get?EmployeeID=' + params?.empid).then(response => {
                    if (response.status === 200 && response.data.rettype === 0) {
                        if (response.data?.retdata?.length > 0 && response.data?.retdata[0]) {
                            tDUser = response.data?.retdata[0];
                        }
                    }
                });
                await API.get("/api/payroll/additional/getempextralist?empid=" + params?.empid + "&isactive=" + p_filter).then(response => {
                    if (response.status === 200 && response.data.retType === 0) {
                        tData = response.data.retData;
                    }
                });
            } finally {
                setLoading(false);
            }
        }
        setDUser(tDUser);
        setData(tData);
        setOData(tData);
    }

    useEffect(() => {
        getData(filterValue);
    }, [params?.empid]);

    const afterSaveNew = () => {
        setShowAddBenefit(false);
        setEntryId(-1);
        getData(filterValue);
    }

    const onSearch = (p_data) => {
        setData(p_data);
    }

    const onDismiss = () => {
        setEntryId(-1);
        setShowAddBenefit(false);
    }

    const onChangeFilter = (p_key) => {
        setFilterValue(p_key);
        getData(p_key);
    }

    return (
        <div>
            <PageHeader
                showLeftFilter
                changeFilter={onChangeFilter}
                filterValue={filterValue}
                filterData={filterData}
                title=""
                buttonTitle="Нэмэгдэл нэмэх"
                onButtonClick={() => {
                    setEntryId(-1);
                    setShowAddBenefit(true);
                }}
                dataCount={data?.length}
                columns={columns}
                data={oData}
                filteredData={data}
                onSearch={onSearch}
                loading={loading}
            />
            <GridDefaultShimmer
                columns={columns}
                data={data}
                loading={loading}
            />
            <BenefitNewBusiness
                entryid={entryid}
                empid={params?.empid}
                fullname={dUser.fullname}
                isOpen={showAddBenefit}
                onDismiss={onDismiss}
                afterSave={afterSaveNew} />
        </div>
    );
}

export default EmpExtraBusiness;